import { Grid, Flex } from 'theme-ui';

import { CtaSearch } from './CtaSearch';
import { CtaAccount } from './CtaAccount';
import { CtaCart } from './CtaCart';
import { CtaWishlist } from './CtaWishlist';
import { CtaRefer } from './CtaRefer';
import { themed } from '../Menu.theme';

export const Ctas = themed(({ theme, adminLinksColor }) => {
  return (
    <Flex sx={{ height: '100%', alignItems: 'center', color: adminLinksColor }}>
      <CtaRefer
        sx={{
          display: ['none', null, 'block'],
        }}
        adminLinksColor={adminLinksColor}
      />
      <Grid data-comp={Ctas.displayName} sx={theme.ctas}>
        <CtaWishlist sx={{ display: ['none', null, 'block'] }} adminLinksColor={adminLinksColor} />

        <CtaSearch adminLinksColor={adminLinksColor} />

        <CtaAccount sx={{ display: ['none', null, 'block'] }} adminLinksColor={adminLinksColor} />
      </Grid>

      <CtaCart adminLinksColor={adminLinksColor} />
    </Flex>
  );
});

Ctas.displayName = 'Ctas';